import {
  Button,
  IconButton,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
  Stack,
} from "@mui/material";
import React, { useState } from "react";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ShareIcon from "@mui/icons-material/Share";
import { useLocation } from "react-router-dom";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import XIcon from "@mui/icons-material/X";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { useDispatch, useSelector } from "react-redux";
import { setSnackMessage } from "../../utils/globalSlice";

const CardButtons = ({ favourite, share, status, slug, carname, carId }) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const handleFavourite = (event) => {
    event.stopPropagation();
    dispatch(
      setSnackMessage({
        open: true,
        message: `${carname} added to favourites!!`,
        variant: "success",
      })
    );
  };
  const location = useLocation();

  const isMob = useSelector((state) => state.global.isMobile);

  const actions = [
    { id: 1, icon: <WhatsAppIcon />, name: "Whatsapp" },
    { id: 2, icon: <FacebookIcon />, name: "Facebook" },
    { id: 3, icon: <XIcon />, name: "X" },
    { id: 4, icon: <LinkedInIcon />, name: "LinkedIn" },
    { id: 5, icon: <ContentCopyIcon />, name: "Copy Link" },
  ];

  const handleSpeedDialClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setOpen(!open);
  };
  const linkToShare =
    location.pathname === "/"
      ? `${window.location.href + slug}?carId=${carId}`
      : `${window.location.href}?carId=${carId}`;

  const handleShare = (event, actionId) => {
    // event.stopPropagation();

    switch (actionId) {
      case 1:
        window.open(
          `https://api.whatsapp.com/send/?text=${linkToShare}&type=phone_number&app_absent=0`,
          "_blank"
        );
        break;
      case 2:
        window.open(
          `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            linkToShare
          )}`,
          "_blank"
        );
        break;
      case 3:
        window.open(
          `https://twitter.com/intent/tweet?url=${linkToShare}&via=fazaa4all`,
          "_blank"
        );
        break;
      case 4:
        window.open(
          `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
            linkToShare
          )}`,
          "_blank"
        );
        break;
      case 5:
        navigator.clipboard.writeText(linkToShare).then(() => {
          dispatch(
            setSnackMessage({
              open: true,
              message: "Link copied Successfully!!",
              variant: "success",
            })
          );
        });
        break;

      default:
        break;
    }
  };

  const handleNativeShare = async (event) => {
    event.preventDefault();
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Check out this car from Fazaa!!",
          text: carname,
          url: linkToShare,
        });
        console.log("Content shared successfully");
      } catch (error) {
        console.error("Error sharing content:", error);
      }
    } else {
      dispatch(
        setSnackMessage({
          open: true,
          message: "Web Share API is not supported in your browser.",
          variant: "error",
        })
      );
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Stack direction={"row"} spacing={1} sx={{ alignItems: "flex-start" }}>
      {!!favourite && (
        <IconButton
          size="small"
          sx={{
            backgroundColor: "white.light",
            color: "appBlue.main",
            boxShadow:
              "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
          }}
          // onClick={handleFavourite}
        >
          <FavoriteBorderIcon />
        </IconButton>
      )}
      {!!share && isMob ? (
        <IconButton
          onClick={handleNativeShare}
          size="medium"
          variant="contained"
          color="primary"
          sx={{
            // minWidth: "38px",
            // width: "38px",
            // height: "38px",
            borderRadius: "100px",
            color: "appBlue.main",
            boxShadow:
              "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
            backgroundColor: "white.main",
          }}
        >
          <ShareIcon />
        </IconButton>
      ) : (
        <SpeedDial
          onClick={handleSpeedDialClick}
          onClose={handleClose}
          open={open}
          icon={<SpeedDialIcon icon={<ShareIcon />} />}
          ariaLabel="SpeedDial example"
          direction="left"
          FabProps={{
            size: "small",
            color: "white",
            sx: {
              boxShadow:
                "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
              width: "36px",
              height: "36px",
            },
          }}
          sx={{
            "& svg": {
              fontSize: "1.5rem",
              width: "1em",
              height: "1em",
              color: "appBlue.main",
            },
            marginLeft: "0 !important",
            "& .MuiSpeedDialAction-staticTooltipLabel": {
              marginBottom: "0", // Adjust the space between the label and the action button
            },
            "& .MuiSpeedDialAction-fab": {
              margin: "2px 2px", // Adjust the vertical space between action buttons
              width: "34px",
              height: "34px",
            },
          }}
        >
          {actions.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              onClick={(event) => handleShare(event, action.id)}
              sx={{
                "& svg": {
                  width: "20px",
                  height: "20px",
                },
              }}
            />
          ))}
        </SpeedDial>
      )}
    </Stack>
  );
};

export default CardButtons;
